<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">auto_stories</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('logbook.Logbook') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-3 mt-5">
                        <div class="row">
                        <div class="col-lg-6">
                            <div class="activity-list">
                                <h5>{{ $t('logbook.My_activity') }}</h5>
                                <!-- Show when no activities -->
                                <div v-if="!useractivities || useractivities.length === 0" class="empty-state">
                                    {{ $t('datatable.NoRows') }}
                                </div>
                                <!-- Show activities -->
                                <div
                                    v-else
                                    v-for="(act, idx) in useractivities"
                                    :key="act.id || idx"
                                    class="activity-box"
                                    role="group"
                                    :style="getBarColor(act.activityName)"
                                    :aria-label="`Activiteit: ${act.activityName}`"
                                >
                                    <div class="row">
                                        <div class="label">VeeBoek activiteit:</div>
                                        <div class="value">{{ act.activityName }}</div>
                                    </div>

                                    <div class="row">
                                        <div class="label">Datum/tijd:</div>
                                        <div class="value">{{ act.userActionCreated }}</div>
                                    </div>

                                    <template v-if="act.activityMasterId === 'C11D95CA-F5B4-4336-A1FF-427F38ECF99C'"> <!--Birth-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value" v-if="act.births && act.births.length">                                        
                                                <template v-for="(item, i) in act.births" :key="i">
                                                    <a href="#" @click.prevent="goToAnimal(item.id)" class="link">
                                                        {{ item.studbookNumber }} | {{ item.tagNumber }} | {{ item.birthDate }} | {{ item.gender }} | {{ item.name }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="act.activityMasterId === '7EA8D8E6-FA04-4164-9EF1-06CD108C7259'"> <!--Mating-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value" v-if="act.matings && act.matings.length">
                                                <div
                                                    class="p-1 mb-1 rounded bg-gradient-light border-start border-4 border-success"
                                                    @click.prevent="goToMating(act.activityRelationId)"
                                                    style="cursor: pointer; width: fit-content;"
                                                >
                                                    <strong class="me-2">
                                                        Dekking
                                                    </strong>
                                                </div>                                        
                                                <template v-for="(item, i) in act.matings" :key="i">
                                                    <a href="#" @click.prevent="goToAnimal(item.maleId)" class="link">
                                                    {{ item.maleStudbookNumber }} | {{ item.maleName }}
                                                    </a>
                                                    + 
                                                    <a href="#" @click.prevent="goToAnimal(item.femaleId)" class="link">
                                                    {{ item.femaleStudbookNumber }} | {{ item.femaleName }}
                                                    </a>

                                                    <br v-if="i < act.matings.length - 1" />
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="act.activityMasterId === '71A5A072-5B5C-412A-B509-1BD43765E81B'"> <!--Departure-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value" v-if="act.departures && act.departures.length">
                                                <div
                                                    class="p-1 mb-1 rounded bg-gradient-light border-start border-4 border-success"
                                                    @click.prevent="goToDeparture(act.activityRelationId)"
                                                    style="cursor: pointer; width: fit-content;"
                                                >
                                                    <strong class="me-2">
                                                        {{ $t('departure.Departure_from_UBN') }}: {{ act.departures[0].fromUbn }} | {{ $t('departure.Departure_to') }}: {{ act.departures[0].toUbn }} | {{ $t('departure.Date') }}: {{ act.departures[0].movementDate }}
                                                    </strong>
                                                </div>
                                                <template v-for="(item, i) in act.departures" :key="i">                                            
                                                    {{ item.studbookNumber }} | {{ item.tagNumber }} | {{ item.name }}                                            
                                                    <br v-if="i < act.departures.length - 1" />
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="act.activityMasterId === 'AB11D696-85CD-4178-B2CC-1D0673B06DB2'"> <!--Death-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>

                                            <!-- SAFE access -->
                                            <div class="value" v-if="Array.isArray(act.deaths) && act.deaths.length > 0">
                                            <div
                                                class="p-1 mb-1 rounded bg-gradient-light border-start border-4 border-success"
                                                @click.prevent="goToDeath(act.activityRelationId)"
                                                style="cursor: pointer; width: fit-content;"
                                            >
                                                <strong class="me-2">
                                                {{ $t('death.Death_from_UBN') }}: {{ act.deaths[0].fromUbn }}
                                                |
                                                {{ $t('death.Destructor') }}: {{ act.deaths[0].toUbn }}
                                                |
                                                {{ $t('death.Date_of_death') }}: {{ act.deaths[0].movementDate }}
                                                </strong>
                                            </div>

                                            <template v-for="(item, i) in act.deaths" :key="i">
                                                {{ item.studbookNumber }} | {{ item.tagNumber }} | {{ item.name }}
                                                <br v-if="i < act.deaths.length - 1" />
                                            </template>
                                            </div>

                                            <!-- Fallback when deaths is null or empty -->
                                            <div class="value text-muted" v-else>
                                            {{ $t('logbook.No_death_details_available') }}
                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="act.activityRvoCall" class="row">
                                        <div class="label">Verwerkt RVO/I&amp;R:</div>
                                        <div class="value">{{ act.userActionCreated }}</div>
                                    </div>

                                    <div v-else class="row">
                                        <div class="label">Verwerkt RVO/I&amp;R:</div>
                                        <div class="value text-danger">{{ $t('logbook.No_RVO_activity') }}</div>                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6" v-if="userRoleName !== 'Keeper'">
                            <div class="activity-list">
                                <h5>{{ $t('logbook.Keeper_activity') }}</h5>
                                <select id="keeperId" class="form-control form-control-default" v-model="selectedKeeperId" @change="onKeeperChange">
                                    <option value="">{{ $t('location.Select_keeper') }}</option>
                                    <option v-for="keeper in keepers" :key="keeper.id" :value="keeper.id">
                                    {{ keeper.fullname }}
                                    </option>
                                </select>
                                <!-- Show placeholder box when no keeper selected -->
                                <span v-if="!selectedKeeperId" class="text-danger">
                                    {{ $t('logbook.Select_keeper_to_view_activities') }}
                                </span>

                                <!-- Show 'No activity found' box when keeper selected but no activities -->
                                <div v-else-if="selectedKeeperId && (!keeperactivities || keeperactivities.length === 0)"
                                    class="text-center text-muted p-4">
                                    {{ $t('logbook.No_items_to_display') }}
                                </div>                                
                                <strong>No activity for the selected keeper found</strong>                                
                                <div
                                    v-for="(act, idx) in keeperactivities"
                                    :key="act.id || idx"
                                    class="activity-box"
                                    role="group"
                                    :style="getBarColor(act.activityName)"
                                    :aria-label="`Activiteit: ${act.activityName}`"
                                >
                                    <div class="row">
                                        <div class="label">VeeBoek activiteit:</div>
                                        <div class="value">{{ act.activityName }}</div>
                                    </div>

                                    <div class="row">
                                        <div class="label">Datum/tijd:</div>
                                        <div class="value">{{ act.userActionCreated }}</div>
                                    </div>

                                    <template v-if="act.activityMasterId === 'C11D95CA-F5B4-4336-A1FF-427F38ECF99C'"> <!--Birth-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value">                                        
                                                <template v-for="(item, i) in act.births" :key="i">
                                                    <a href="#" @click.prevent="goToAnimal(item.id)" class="link">
                                                        {{ item.studbookNumber }} | {{ item.tagNumber }} | {{ item.birthDate }} | {{ item.gender }} | {{ item.name }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="act.activityMasterId === '7EA8D8E6-FA04-4164-9EF1-06CD108C7259'"> <!--Mating-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value">
                                                <div
                                                    class="p-1 mb-1 rounded bg-gradient-light border-start border-4 border-success"
                                                    @click.prevent="goToMating(act.activityRelationId)"
                                                    style="cursor: pointer; width: fit-content;"
                                                >
                                                    <strong class="me-2">
                                                        Dekking
                                                    </strong>
                                                </div>                                        
                                                <template v-for="(item, i) in act.matings" :key="i">
                                                    <a href="#" @click.prevent="goToAnimal(item.maleId)" class="link">
                                                    {{ item.maleStudbookNumber }} | {{ item.maleName }}
                                                    </a>
                                                    + 
                                                    <a href="#" @click.prevent="goToAnimal(item.femaleId)" class="link">
                                                    {{ item.femaleStudbookNumber }} | {{ item.femaleName }}
                                                    </a>

                                                    <br v-if="i < act.matings.length - 1" />
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="act.activityMasterId === '71A5A072-5B5C-412A-B509-1BD43765E81B'"> <!--Departure-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value" v-if="act.departures && act.departures.length">
                                                <div
                                                    class="p-1 mb-1 rounded bg-gradient-light border-start border-4 border-success"
                                                    @click.prevent="goToDeparture(act.activityRelationId)"
                                                    style="cursor: pointer; width: fit-content;"
                                                >
                                                    <strong class="me-2">
                                                        {{ $t('departure.Departure_from_UBN') }}: {{ act.departures[0].fromUbn }} | {{ $t('departure.Departure_to') }}: {{ act.departures[0].toUbn }} | {{ $t('departure.Date') }}: {{ act.departures[0].movementDate }}
                                                    </strong>
                                                </div>
                                                <template v-for="(item, i) in act.departures" :key="i">                                            
                                                    {{ item.studbookNumber }} | {{ item.tagNumber }} | {{ item.name }}                                            
                                                    <br v-if="i < act.departures.length - 1" />
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="act.activityMasterId === 'AB11D696-85CD-4178-B2CC-1D0673B06DB2'"> <!--Death-->
                                        <div class="row">
                                            <div class="label">Verwijzing:</div>
                                            <div class="value">
                                                <div
                                                    class="p-1 mb-1 rounded bg-gradient-light border-start border-4 border-success"
                                                    @click.prevent="goToDeath(act.activityRelationId)"
                                                    style="cursor: pointer; width: fit-content;"
                                                >
                                                    <strong class="me-2">
                                                        {{ $t('death.Death_from_UBN') }}: {{ act.deaths[0].fromUbn }}
                                                        |
                                                        {{ $t('death.Destructor') }}: {{ act.deaths[0].toUbn }}
                                                        |
                                                        {{ $t('death.Date_of_death') }}: {{ act.deaths[0].movementDate }}
                                                    </strong>
                                                </div>
                                                <template v-for="(item, i) in act.deaths" :key="i">                                            
                                                    {{ item.studbookNumber }} | {{ item.tagNumber }} | {{ item.name }}                                            
                                                    <br v-if="i < act.deaths.length - 1" />
                                                </template>
                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="act.activityRvoCall" class="row">
                                        <div class="label">Verwerkt RVO/I&amp;R:</div>
                                        <div class="value">{{ act.userActionCreated }}</div>
                                    </div>

                                    <div v-else class="row">
                                        <div class="label">Verwerkt RVO/I&amp;R:</div>
                                        <div class="value text-danger">{{ $t('logbook.No_RVO_activity') }}</div>                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import * as Choices from "choices.js";

export default {
    name: 'Logbook_index_page',
    components: {
    },
    data() {
        return {
            useractivities: [],
            keeperactivities: [],
            keepers: [],
            gets: [],            
            selectedKeeperId: ''
        }
    },
    computed: {   
        userRoleName() {
            return this.$store.state.user?.roleName;
        },        
    },
    async mounted() { 
        try {
            this.$store.commit('setShowLoading', true);            
            await this.loadAll();
            
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: {
        async loadAll() {            
            if (this.userRoleName === 'Keeper') {
                await this.fetchUserActivity('');
            } else {                
                await this.fetchAllKeepers();
                await this.fetchUserActivity('');
            }
        },
        async fetchUserActivity(userId) {
            try {
                if (!userId) {
                    this.keeperactivities = [];

                    const response = await axios.get("UserActivity/getall");
                    const result = response.data;
                    const data = result?.data;

                    if (result?.success) {

                        if (!Array.isArray(data) || data.length === 0) {
                            this.useractivities = [];
                            this.$showSuccess(this.$t('errors.No_ear_tags_found'));
                            return;
                        }

                        this.useractivities = data;
                    } 
                    else {
                        this.useractivities = [];
                        this.$showError(this.$t('errors.Contact_system_admin'));
                    }

                    return;
                }

                // Otherwise fetch activities for the given userId
                const response = await axios.get("UserActivity/getall", {
                    params: { id: userId }
                });

                const result = response.data;
                const data = result?.data;

                if (result?.success) {

                    if (!Array.isArray(data) || data.length === 0) {
                        this.keeperactivities = [];
                        this.$showSuccess(this.$t('errors.No_useractivity_found'));
                        return;
                    }

                    this.keeperactivities = data;
                } 
                else {    
                    this.keeperactivities = [];
                    this.$showError(this.$t('errors.Contact_system_admin'));
                }
            } 
            catch (e) {
                this.keeperactivities = [];
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },        
        async fetchAllKeepers() 
        {
            try { 
                const associationId = this.userRoleName === 'Admin' 
                    ? '' 
                    : this.$store.state.associationAdminAssociationId;

                // call API with associationId
                const response = await axios.get("user/getkeepers", {
                    params: { associationId }
                });
                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.keepers = result.data;

                    // Wait for DOM to update
                    this.$nextTick(() => {
                        this.initializeChoicesKeeper(); // Initialize Choices here
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_keepers');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        initializeChoicesKeeper() {                    
            const element = document.getElementById("keeperId");
            if (this.keeperChoicesInstance) {
                this.keeperChoicesInstance.destroy(); // Clean up previous instance      
            }
            
            this.keeperChoicesInstance  = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true, 
                //placeholderValue: '-- Select keeper --', 
            });
        },
        async onKeeperChange() {
             if (!this.selectedKeeperId) {            
                this.keeperactivities = [];
                return;
            }        
            await this.fetchUserActivity(this.selectedKeeperId);
        },
        goToAnimal(id) {
            if (!id) return;
            // use this.$router (Options API)
            this.$router.push({ name: 'Preview Animal', params: { id } })
                .catch(() => { /* ignore navigation duplicate errors if any */ });
        },

        goToMating(id) {
            if (!id) return;
            this.$router.push({ name: 'Preview Mating', params: { id } })
                .catch(() => { /* ignore navigation duplicate errors if any */ });
        },

        goToDeparture(id) {
            if (!id) return;
            this.$router.push({ name: 'Overview Departure', params: { id } })
                .catch(() => { /* ignore navigation duplicate errors if any */ });
        },

        goToDeath(id) {
            if (!id) return;
            this.$router.push({ name: 'Overview Death', params: { id } })
                .catch(() => { /* ignore navigation duplicate errors if any */ });
        },

        getBarColor(activityName) {
            if (activityName?.includes('Afvoer')) return { borderLeft: '6px solid #71d0df' } // departure 
            if (activityName?.includes('Sterfte')) return { borderLeft: '6px solid #dc3545' } // death red
            if (activityName?.includes('Geboorte')) return { borderLeft: '6px solid #0f8d09' } // birth green
            if (activityName?.includes('Paring aangemaakt')) return { borderLeft: '6px solid #ff8209' } // mating orange            
            return { borderLeft: '6px solid #2d6ebb' } // default blue
        }
    }
}
</script>
<style scoped>
    .activity-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0.25rem;        
    }

    .empty-state {
        text-align: center;
        padding: 25px;
        color: #7b8a9a;
        font-size: 14px;
    }

    /* box style like your image: rounded, blue border, subtle bg */
    .activity-box {
        /*border: 2px solid #3b6fb5; /* blue border */
        /*border-radius: 14px;
        padding: 14px 16px;
        background: #fff;
        max-width: 680px; /* adjust as needed */
        /*box-shadow: 0 2px 6px rgba(0,0,0,0.04);
        font-size: 13px;*/

        border: 1.5px solid #2d6ebb;
        border-left: 6px solid #2d6ebb; /* ✅ left color bar */
        border-radius: 10px;
        padding: 12px 18px;
        background: #fff;
        max-width: 700px;
        margin-bottom: 1rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        font-size: 13px;
    }

    /* row layout */
    .row {
        display: flex;
        flex-wrap: wrap;        
    }

    .label {
        width: 200px;
        font-weight: 600;
        color: #103a63;
    }

    .value {
        flex: 1;
        color: #223449;
        word-break: break-word;
    }

    /* reference link styling - blue and underlined like screenshot */
    .ref-link {
        text-decoration: underline;
        color: #1b66b1;
        font-weight: 500;
        white-space: nowrap;
    }

    /* thin separator between refs */
    .sep {
        margin: 0 6px;
        color: #8a9db9;
    }

    .link {
        color: #1b66b1;
        text-decoration: underline;
        cursor: pointer;
    }
    .link:hover {
        color: #0d4e8a;
    }

    /* responsive tweak */
    @media (max-width: 520px) {
        .activity-box { padding: 12px; }
        .label { min-width: 120px; font-size: 13px; }
        .ref-link, .ref-text { font-size: 13px; }
    }
</style>